import React, { useRef, useEffect } from "react";
import { useCountDown, useSetState } from "ahooks";
import VisibleHook from "../../../../tool/visibleHook";
import styles from "./index.module.scss";
import { classNames, toFixedString, caclCurrentZodiac } from "../../../../tool";

export default function ShopCart(props) {
  const {
    visible,
    handleHide,
    type,
    onDelete,
    currentIssue,
    balanceInfo,
    selectPlays,
    showSelectPlays,
    handleSelectPlays,
    secondPlay,
    handleBet,
    firstPlay,
    money,
    playOddInfo,
    getBalanceInfo,
  } = props;
  const { stime, rowId } = currentIssue || {};
  const { containerVisible, contentVisible } = VisibleHook({ visible });

  const [state, setState] = useSetState({
    editedMoney: "",
    singleMoney: "",
    multiple: 1,
  });
  const { editedMoney, singleMoney, multiple } = state;
  const isSpecialRef = useRef(
    (firstPlay.code === "HX" ||
      firstPlay.code === "LXLW" ||
      firstPlay.code === "LM" ||
      firstPlay.code === "ZXBZ") &&
      showSelectPlays.length > 0
  );
  const realSelectPlaysRef = useRef(false);
  const oddsRef = useRef(false);
  useEffect(() => {
    setState({
      editedMoney: money,
      singleMoney: money,
      multiple: 1,
    });
  }, [money]);
  useEffect(() => {
    if (!visible) {
      setState({
        editedMoney: money,
        singleMoney: money,
        multiple: 1,
      });
    }
  }, [visible]);
  useEffect(() => {
    realSelectPlaysRef.current = selectPlays;
    if (selectPlays.length) {
      oddsRef.current =
        playOddInfo[
          `LHC_${selectPlays[0].firstCode}_${
            selectPlays[0].secondCode || selectPlays[0].firstCode
          }${selectPlays[0].code}${
            selectPlays[0].name === caclCurrentZodiac() ? 0 : ""
          }`
        ];
    }

    if (
      (firstPlay.code === "HX" ||
        firstPlay.code === "LXLW" ||
        firstPlay.code === "LM" ||
        firstPlay.code === "ZXBZ") &&
      showSelectPlays.length > 0
    ) {
      isSpecialRef.current = true;
      const arr = showSelectPlays.map((item) => {
        const codeArrInit = item.map((i) => i.code);
        const codeArr = JSON.parse(JSON.stringify(codeArrInit)).reverse();
        const realName = codeArr.join("|");
        return {
          ...item[0],
          name: realName,
        };
      });
      realSelectPlaysRef.current = arr;
    } else {
      isSpecialRef.current = false;
    }
  }, [selectPlays]);
  const onChangeMoney = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    setState({
      editedMoney: val,
    });
  };
  const onChangeSingleMoney = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    setState({
      singleMoney: val,
      multiple: 1,
    });
  };
  const [time, formattedRes] = useCountDown({
    targetDate: stime,
    onEnd: () => {
      handleHide();
    },
  });
  if (!selectPlays.length) {
    return <span></span>;
  }
  return (
    <div
      className={classNames(
        styles.container,
        containerVisible ? styles.showMask : ""
      )}
    >
      <div
        className={classNames(
          styles.content,

          (visible ? contentVisible : visible) ? styles.show : ""
        )}
      >
        <div className={styles.header}>
          <div className={styles.back} onClick={handleHide}>
            <img src={require("../../../../assets/imgs/new/icon_back.png")} />
          </div>
          <div className={styles.title}>
            {type === 1 ? "购物车" : "下注信息"}
          </div>
          <div className={styles.deleteAll} onClick={onDelete}>
            全部删除
          </div>
        </div>
        <div className={styles.topInfo}>
          <div className={styles.issueInfo}>
            <div className={styles.issue}>
              <img
                className={styles.iconClock}
                src={require("../../../../assets/imgs/new/icon_lock.png")}
              />
              <div className={styles.issueText}>
                第<span>{rowId}</span>期 截止
              </div>
            </div>
            <div className={styles.time}>
              {formattedRes.hours < 10
                ? "0" + formattedRes.hours
                : formattedRes.hours}
              :
              {formattedRes.minutes < 10
                ? "0" + formattedRes.minutes
                : formattedRes.minutes}
              :
              {formattedRes.seconds < 10
                ? "0" + formattedRes.seconds
                : formattedRes.seconds}
            </div>
          </div>
          <div className={styles.balanceInfo}>
            <div className={styles.balanceText} onClick={getBalanceInfo}>
              <img
                className={styles.balanceIcon}
                src={require("../../../../assets/imgs/new/balance.png")}
              />
              账户余额
              <img
                className={styles.refreshIcon}
                src={require("../../../../assets/imgs/new/balance_refresh.png")}
              />
            </div>
            <div className={styles.balance}>{balanceInfo.balance}</div>
          </div>
        </div>
        <div className={styles.moneyChangeContainer}>
          <div className={styles.inputContainer}>
            <div className={styles.label}>金额</div>
            <input
              inputMode="decimal"
              className={styles.moneyInput}
              placeholder="输入您批量修改的金额/可不设置"
              onChange={onChangeMoney}
              maxLength={8}
              value={editedMoney}
            />
          </div>
          <div
            className={styles.editBtn}
            onClick={() => {
              setState({
                multiple: 1,
                singleMoney: editedMoney,
              });
            }}
          >
            批量修改
          </div>
        </div>
        <div className={styles.scrollContent}>
          <div className={styles.betItemList}>
            {isSpecialRef.current ? (
              <div className={styles.betItem}>
                <div className={styles.issueTop}>
                  <div className={styles.issue}>
                    第<span>{rowId}</span>期
                  </div>
                  <div className={styles.delete} onClick={onDelete}>
                    <img src={require("../../../../assets/imgs/new/del.png")} />
                    删除
                  </div>
                </div>
                <div className={styles.betInfo}>
                  <div className={styles.name}>{`${selectPlays[0].firstName}${
                    selectPlays[0].secondName
                      ? "-" + selectPlays[0].secondName
                      : ""
                  }`}</div>
                  <div className={styles.odds}>
                    @
                    {selectPlays.map((item, index) => {
                      return (
                        <>
                          {item.name}
                          {index === selectPlays.length - 1 ? "" : " | "}
                        </>
                      );
                    })}
                  </div>
                </div>

                <div className={styles.betMoney}>
                  <div className={styles.label}>金额</div>
                  <div className={styles.moneyContainer}>
                    <div
                      className={styles.reduce}
                      onClick={() => {
                        setState({
                          multiple: multiple - 1 < 1 ? 1 : multiple - 1,
                        });
                      }}
                    >
                      <img
                        src={require("../../../../assets/imgs/new/reduce.png")}
                      />
                    </div>
                    <input
                      inputMode="decimal"
                      className={styles.moneyInput}
                      onChange={onChangeSingleMoney}
                      maxLength={8}
                      value={singleMoney * multiple}
                    />
                    <div
                      className={styles.add}
                      onClick={() => {
                        setState({
                          multiple: multiple + 1,
                        });
                      }}
                    >
                      <img
                        src={require("../../../../assets/imgs/new/add.png")}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.itemTotal}>
                  <div className={styles.calcTotal}>
                    共{realSelectPlaysRef.current.length}注，累计
                    {toFixedString(
                      realSelectPlaysRef.current.length * singleMoney * multiple
                    )}
                    元
                  </div>
                  <div className={styles.itemOdds}>赔率：{oddsRef.current}</div>
                </div>
              </div>
            ) : (
              selectPlays.map((item, index) => {
                const odds =
                  playOddInfo[
                    `LHC_${item.firstCode}_${
                      item.secondCode || item.firstCode
                    }${item.code}${item.name === caclCurrentZodiac() ? 0 : ""}`
                  ];
                return (
                  <div className={styles.betItem} key={index}>
                    <div className={styles.issueTop}>
                      <div className={styles.issue}>
                        第<span>{rowId}</span>期
                      </div>
                      <div
                        className={styles.delete}
                        onClick={() => {
                          handleSelectPlays(item, secondPlay);
                        }}
                      >
                        <img
                          src={require("../../../../assets/imgs/new/del.png")}
                        />
                        删除
                      </div>
                    </div>
                    <div className={styles.betInfo}>
                      <div className={styles.name}>{`${item.firstName}${
                        item.secondName && item.secondName !== item.firstName
                          ? "-" + item.secondName
                          : ""
                      }`}</div>
                      <div className={styles.odds}>@{item.name}</div>
                    </div>
                    <div className={styles.betMoney}>
                      <div className={styles.label}>金额</div>
                      <div className={styles.moneyContainer}>
                        <div
                          className={styles.reduce}
                          onClick={() => {
                            setState({
                              multiple: multiple - 1 < 1 ? 1 : multiple - 1,
                            });
                          }}
                        >
                          <img
                            src={require("../../../../assets/imgs/new/reduce.png")}
                          />
                        </div>
                        <input
                          inputMode="decimal"
                          className={styles.moneyInput}
                          onChange={onChangeSingleMoney}
                          maxLength={8}
                          value={singleMoney * multiple}
                        />
                        <div
                          className={styles.add}
                          onClick={() => {
                            setState({
                              multiple: multiple + 1,
                            });
                          }}
                        >
                          <img
                            src={require("../../../../assets/imgs/new/add.png")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={styles.itemTotal}>
                      <div className={styles.calcTotal}>
                        共1注，累计{toFixedString(singleMoney * multiple)}元
                      </div>
                      <div className={styles.itemOdds}>赔率：{odds}</div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.totalInfo}>
            <div className={classNames(styles.totalCount)}>
              总注单数：
              <span>{realSelectPlaysRef.current.length}</span>
            </div>
            <div className={classNames(styles.totalCount, styles.totalMoney)}>
              总投注额：
              <span className={styles.moneyIcon}>￥</span>
              <span>
                {realSelectPlaysRef.current.length * singleMoney * multiple}
              </span>
            </div>
          </div>
          <div
            className={styles.betBtn}
            onClick={() => {
              handleBet(singleMoney * multiple);
            }}
          >
            立即投注
          </div>
        </div>
      </div>
    </div>
  );
}
